import { ResolvableModeEnum } from '@e-socna/data-layer';

import { ServiceUsagesGroups } from '../../../components/ServiceUsages/Groups';

import { useOptionGroupsSelection } from '../hooks/useOptionGroupsSelection.hook';
import type { SubMissionPricing } from '../types/sub-mission-pricing.type';

interface Props {
  // The options of the sub-mission are chosen in the edition mode only.
  readonly isEditionMode: boolean;
  readonly subMission: SubMissionPricing;
}

const RESOLVABLE_FIELD_SETTINGS = {
  enableDirectGeneration: false,
  primaryMode: ResolvableModeEnum.Static,
};

// The pricing of a sub-mission, its option choice saved on the sub-mission.
export const SubMissionPricingDetail = ({
  isEditionMode,
  subMission,
}: Readonly<Props>) => {
  const { pricing } = subMission;
  const optionGroupsSelection = useOptionGroupsSelection({
    isEditable: isEditionMode && pricing.isOptionGroupsSelectionEditable,
    missionId: subMission._id,
  });

  return (
    <ServiceUsagesGroups
      consultResolvableServiceInNewTab
      editionMode={false}
      fallbackServiceUsagesGroups={pricing.fallbackServiceUsagesGroups}
      groupTotalCalculations={pricing.groupTotalCalculations}
      isInResolvableMode
      optionGroupsSelection={optionGroupsSelection}
      resolvableFieldSettings={RESOLVABLE_FIELD_SETTINGS}
      selectedOptionGroupIds={pricing.selectedOptionGroupIds}
      serviceUsagesGroups={pricing.serviceUsagesGroups}
      // Inheriting or specializing the pricing is done on the sub-mission
      // itself, not from its collaboration.
      showInheritanceAlert={false}
      totalCalculation={pricing.totalCalculation}
    />
  );
};
